import { memo, useEffect } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
} from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import toast from "react-hot-toast";
import axios from "axios";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useDispatch } from "react-redux";
import { showModal, hideConfirmModal } from "../../redux/counterSlice";
import { FormInputText } from "../../components/form-components/FormInputText";

const categoryCodeSchema = yup.object().shape({
  category_code: yup
    .string()
    .required("Category code is required")
    .max(20, "Max 20 characters"),
});

const AddCategoryCode = ({
  open,
  handleClose,
  selectedRow,
  loadInitialData,
}) => {
  const dispatch = useDispatch();
  const isEditMode = selectedRow && selectedRow.cat_code_id;

  const {
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(categoryCodeSchema),
    defaultValues: { category_code: "" },
  });

  useEffect(() => {
    if (isEditMode && selectedRow) {
      reset({ category_code: selectedRow.category_code || "" });
    } else {
      reset({ category_code: "" });
    }
  }, [selectedRow, isEditMode, reset]);

  const onSubmit = async (data) => {
    const payload = {
      category_code: data.category_code,
      ...(isEditMode && { cat_code_id: selectedRow.cat_code_id }),
    };

    try {
      const response = isEditMode
        ? await axios.put(`/category_code/${selectedRow.cat_code_id}`, { category_code: data.category_code })
        : await axios.post("/category_code", payload);

      if (!response?.data?.error) {
        toast.success(response?.data?.message || "Saved successfully");
        loadInitialData();
        reset();
        handleClose();
      } else {
        let errDesc = response?.data?.message || "Something went wrong";
        if (response?.data?.data) {
          errDesc = Object.values(response.data.data).join("\n");
        }
        dispatch(showModal({ msg: errDesc, error: true }));
      }
    } catch (error) {
      dispatch(
        showModal({ msg: error?.message || "Server error", error: true })
      );
    } finally {
      dispatch(hideConfirmModal({ msg: "" }));
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle className="text-primary">
        {isEditMode ? "Edit Category Code" : "Add Category Code"}
      </DialogTitle>
      <DialogContent>
        <form id="add-category-code-form" onSubmit={handleSubmit(onSubmit)}>
          <Grid container spacing={2} sx={{ mt: 0.5 }}>
            <Grid item xs={12}>
              <FormInputText
                name="category_code"
                control={control}
                label="Category Code"
                errors={errors}
                mandatory="true"
              />
            </Grid>
          </Grid>
        </form>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} variant="contained" color="error">
          Cancel
        </Button>
        <Button
          type="submit"
          form="add-category-code-form"
          color="primary"
          variant="contained"
          startIcon={<SaveIcon />}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default memo(AddCategoryCode);